const onInvoicePageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector(
      '.PageContent.form-content-with-pdf'
    )

    if (pageContent) {
      clearInterval(waitForPageLoad)
      caseComboBox()  
      // setupDuplicateInvoiceCheck()

      const existingNotesSection = document.querySelector('.notes-section')
      if (existingNotesSection) {
        return
      }

      console.log('onInvoicePageMatch')
      var notesSection = document.createElement('div')
      notesSection.className = 'notes-section'
      notesSection.style.margin = '24px'
      notesSection.style.position = 'relative'
      notesSection.style.padding = '24px'
      notesSection.style.backgroundColor = 'rgb(250, 250, 250)'
      notesSection.style.paddingLeft = '88px' // Indent by 40 additional px left
      notesSection.style.borderRadius = '0.8rem'

      var indicator = document.createElement('div')
      indicator.style.position = 'absolute'
      indicator.style.width = '40px'
      indicator.style.height = '40px'
      indicator.style.top = '24px'
      indicator.style.left = '24px'
      indicator.style.borderRadius = '50%'
      indicator.style.backgroundColor = '#eee' // Example color for visibility
      indicator.style.color = 'rgba(0, 0, 0, 0.85)'
      indicator.style.fontWeight = '500'
      indicator.style.fontSize = '18px'
      indicator.style.textAlign = 'center'
      indicator.style.lineHeight = '40px'
      indicator.textContent = '0'

      var heading = document.createElement('h2')
      heading.className = 'text-lg font-semibold mb-2'
      heading.textContent = 'Notizen und Freigabe'

      var textarea = document.createElement('textarea')
      textarea.className =
        'w-full border-2 border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500'
      textarea.style.padding = '8px 16px'
      textarea.style.borderWidth = '2px'
      textarea.style.borderColor = 'rgb(238, 238, 238)'
      textarea.style.width = '100%'
      textarea.style.borderRadius = '0.6rem'
      textarea.style.marginBottom = '8px'
      textarea.placeholder = 'Hier Notizen eingeben...'

      var debounceTimeout
      textarea.addEventListener('input', function () {
        clearTimeout(debounceTimeout)
        debounceTimeout = setTimeout(function () {
          var currentDate = new Date()
          var noteContent = textarea.value
          var userEmail = JSON.parse(localStorage.auth).email.replace(
            /\./g,
            ' '
          )
          var userName = userEmail.substring(0, userEmail.indexOf('@'))
          userName = userName
            .split(' ')
            .map(function (word) {
              return word.charAt(0).toUpperCase() + word.slice(1)
            })
            .join(' ')

          var formattedDate =
            currentDate.getDate().toString().padStart(2, '0') +
            '.' +
            (currentDate.getMonth() + 1).toString().padStart(2, '0') +
            '.' +
            currentDate.getFullYear().toString().slice(-2) +
            ' ' +
            currentDate.getHours().toString().padStart(2, '0') +
            ':' +
            currentDate.getMinutes().toString().padStart(2, '0')

          try {
            var xhr = new XMLHttpRequest()
            xhr.open('POST', `${baseApiUrl}/api/invoiceNotes/set`, true)
            xhr.setRequestHeader('Content-Type', 'application/json')
            xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.auth).token}`)
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  console.log('Note sent successfully')
                } else {
                  console.error('Failed to send note:', xhr.statusText)
                }
              }
            }
            xhr.send(
              JSON.stringify({
                userName: userName,
                date: formattedDate,
                invoiceId: window.location.pathname.split('/').pop(),
                domain: resolveDomain(JSON.parse(localStorage.auth).domain),
                eventType: 'TEXT_UPDATE',
                note: noteContent,
              })
            )
          } catch (error) {
            console.error('Error sending note:', error)
          }
        }, 500)
      })

      var addButton = document.createElement('button')
      addButton.textContent = '+ Anhang hochladen'
      addButton.style.color = '#000'
      addButton.style.backgroundColor = 'rgba(0, 0, 0, .08)'
      addButton.style.padding = '.4rem 1rem'
      addButton.style.border = 'none'
      addButton.style.fontSize = '1.6rem'
      addButton.style.borderRadius = '.4rem'
      addButton.style.marginBottom = '8px'
      addButton.style.cursor = 'pointer'

      addButton.addEventListener('mouseover', function () {
        addButton.style.backgroundColor = 'rgba(0, 0, 0, .16)'
      })

      addButton.addEventListener('mouseout', function () {
        addButton.style.backgroundColor = 'rgba(0, 0, 0, .08)'
      })

      addButton.addEventListener('click', function () {
        var fileInput = document.createElement('input')
        fileInput.type = 'file'
        fileInput.style.display = 'none'
        fileInput.multiple = true // Allow multiple file uploads
        fileInput.click() // Programmatically click the file input to open the dialog
        fileInput.addEventListener('change', function (event) {
          var files = event.target.files
          if (files.length > 0) {
            var fileNames = Array.from(files).map((file) => file.name)
            console.log('Files selected:', fileNames)

            var userEmail = JSON.parse(localStorage.auth).email.replace(
              /\./g,
              ' '
            )
            var userName = userEmail.substring(0, userEmail.indexOf('@'))
            userName = userName
              .split(' ')
              .map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1)
              })
              .join(' ')

            var currentDate = new Date()
            var formattedDate =
              currentDate.getFullYear() +
              '-' +
              (currentDate.getMonth() + 1).toString().padStart(2, '0') +
              '-' +
              currentDate.getDate().toString().padStart(2, '0') +
              ' ' +
              currentDate.getHours().toString().padStart(2, '0') +
              ':' +
              currentDate.getMinutes().toString().padStart(2, '0') +
              ':' +
              currentDate.getSeconds().toString().padStart(2, '0')

            var filesData = []
            var filesProcessed = 0

            Array.from(files).forEach((file) => {
              var reader = new FileReader()
              reader.onload = function (event) {
                filesData.push({
                  fileName: file.name,
                  fileBlob: event.target.result,
                })
                filesProcessed++
                if (filesProcessed === files.length) {
                  fetch(`${baseApiUrl}/api/invoiceNotes/set`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
                    },
                    body: JSON.stringify({
                      userName: userName,
                      formattedDate: formattedDate,
                      invoiceId: window.location.pathname.split('/').pop(),
                      domain: resolveDomain(JSON.parse(localStorage.auth).domain),
                      files: filesData,
                      eventType: 'FILES_UPDATED', // Ensure the correct event type is sent
                    }),
                  })
                }
              }
              reader.readAsDataURL(file)
            })
          }
        })
      })

      var checkboxContainer = document.createElement('div')
      // hide the checkbox container initially till the data is fetched to avoid flickering
      checkboxContainer.style.display = 'none'
      checkboxContainer.style.alignItems = 'center'
      checkboxContainer.style.marginTop = '8px'
      checkboxContainer.style.marginBottom = '8px'

      var checkbox = document.createElement('input')
      checkbox.type = 'checkbox'
      checkbox.id = 'freigegeben'
      checkbox.className = 'mr-2'
      checkbox.style.width = '24px'
      checkbox.style.height = '24px'
      checkbox.style.accentColor = 'rgba(0, 0, 0, 0.85)'

      var checkboxLabel = document.createElement('label')
      checkboxLabel.htmlFor = 'freigegeben'
      checkboxLabel.textContent = 'Freigegeben'
      checkboxLabel.className = 'text-sm font-medium'
      checkboxLabel.style.marginLeft = '4px'
      checkboxLabel.style.fontSize = '16px'
      checkboxLabel.style.lineHeight = '24px'

      var checkboxManagerApprovaContainer = document.createElement('div')
      checkboxManagerApprovaContainer.style.display = 'none'
      checkboxManagerApprovaContainer.style.alignItems = 'center'
      checkboxManagerApprovaContainer.style.marginTop = '8px'
      checkboxManagerApprovaContainer.style.marginBottom = '8px'

      var checkboxManagerApprovalChecboxContainer = document.createElement('div')
      checkboxManagerApprovalChecboxContainer.style.display = 'flex'

      var checkboxManagerApproval = document.createElement('input')
      checkboxManagerApproval.type = 'checkbox'
      checkboxManagerApproval.id = 'freigegebenManagerApproval'
      checkboxManagerApproval.className = 'ml-6 mr-2'
      checkboxManagerApproval.style.width = '24px'
      checkboxManagerApproval.style.height = '24px'
      checkboxManagerApproval.style.accentColor = 'rgba(0, 0, 0, 0.85)'

      var checkboxLabelManagerApproval = document.createElement('label')
      checkboxLabelManagerApproval.htmlFor = 'freigegebenManagerApproval'
      checkboxLabelManagerApproval.textContent = 'Freigegeben durch Manager'
      checkboxLabelManagerApproval.className = 'text-sm font-medium'
      checkboxLabelManagerApproval.style.marginLeft = '4px'
      checkboxLabelManagerApproval.style.fontSize = '16px'
      checkboxLabelManagerApproval.style.lineHeight = '24px'

      var clickedByLabel = document.createElement('p')
      clickedByLabel.className = 'text-xs text-gray-500 mt-1'

      var clickedByLabelManagerApproval = document.createElement('p')
      clickedByLabelManagerApproval.className = 'text-xs text-gray-500'
      clickedByLabelManagerApproval.style.marginTop = '16px'

      function handleCheckboxChange(event) {
        var checkboxId = this.id || event.target.id
        var userEmail = JSON.parse(localStorage.auth).email.replace(
          /\./g,
          ' '
        )
        var userName = userEmail.substring(0, userEmail.indexOf('@'))
        userName = userName
          .split(' ')
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1)
          })
          .join(' ')
        var currentDate = new Date()
        var formattedDate =
          currentDate.getDate().toString().padStart(2, '0') +
          '.' +
          (currentDate.getMonth() + 1).toString().padStart(2, '0') +
          '.' +
          currentDate.getFullYear().toString().slice(-2) +
          ' ' +
          currentDate.getHours().toString().padStart(2, '0') +
          ':' +
          currentDate.getMinutes().toString().padStart(2, '0')

        if(checkboxId == 'freigegeben'){
          clickedByLabel.style.display = this.checked ? 'block' : 'none'
          clickedByLabel.textContent =
            'Freigegeben durch: ' + userName + ' am ' + formattedDate
        } else if(checkboxId == 'freigegebenManagerApproval'){
          clickedByLabelManagerApproval.style.display = this.checked ? 'block' : 'none'
          clickedByLabelManagerApproval.textContent =
            'Freigegeben durch Manager: ' + userName + ' am ' + formattedDate
            if(this.checked && !checkbox.checked) {
              checkbox.checked = true;
              clickedByLabel.style.display = 'block'
              clickedByLabel.textContent =
              'Freigegeben durch: ' + userName + ' am ' + formattedDate   
            }
        }

        var xhr = new XMLHttpRequest()
        xhr.open('POST', `${baseApiUrl}/api/invoiceNotes/set`, true)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.auth).token}`)
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              console.log('Success:', xhr.responseText)
            } else {
              console.error('Error:', xhr.statusText)
            }
          }
        }
        
        const eventTypeByCheckboxId ={
          'freigegeben':{
            true: 'ACCEPTED',
            false: 'DENIED',
          },
          'freigegebenManagerApproval': {
            true: 'MANAGER_APPROVAL_REQUIRED_ACCEPTED',
            false: 'MANAGER_APPROVAL_REQUIRED_DENIED',
          },
        }

        xhr.send(
          JSON.stringify({
            userName: userName,
            date: formattedDate,
            invoiceId: window.location.pathname.split('/').pop(),
            domain: resolveDomain(JSON.parse(localStorage.auth).domain),
            eventType:  eventTypeByCheckboxId[checkboxId][this.checked],
          })
        )
      }
      checkbox.addEventListener('change', handleCheckboxChange)
      checkboxManagerApproval.addEventListener('change', handleCheckboxChange)

      clickedByLabel.style.display = 'none'
      clickedByLabelManagerApproval.style.display = 'none'

      // Create a container for the list of attachment names
      var attachmentListContainer = document.createElement('div')
      attachmentListContainer.style.marginTop = '8px'
      attachmentListContainer.style.fontSize = '14px'
      attachmentListContainer.style.color = '#333'

      // Fetch and display the list of attachment names
      var xhr = new XMLHttpRequest()
      xhr.open('POST', `${baseApiUrl}/api/invoiceNotes/get`, true)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.auth).token}`)
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          // show the checkbox container after the data is fetched
          checkboxContainer.style.display = 'flex'
          if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText)
            var invoiceNote =
              data.invoiceNote.length > 0
                ? data.invoiceNote[0]
                : null
            var invoiceAttachments = data.invoiceAttachments.value
            var invoiceApprovingManager = data.invoiceApprovingManager
            const maximumInvoiceAmount = data.maximumInvoiceAmount
            const totalGross = data.totalGross * -1
            if(maximumInvoiceAmount > 0 && totalGross >= maximumInvoiceAmount){
              checkboxManagerApprovaContainer.style.display = 'block'
            }
            if(invoiceApprovingManager && invoiceApprovingManager !== JSON.parse(localStorage.auth).email){
              checkboxManagerApproval.disabled = true
              checkboxManagerApproval.style.opacity = '0.5'
              checkboxLabelManagerApproval.style.opacity = '0.5'
            }
            textarea.value = invoiceNote.note
            checkbox.checked = invoiceNote.checked
            checkboxManagerApproval.checked = invoiceNote.checkedManagerApproval
            if (invoiceNote.checked) {
              clickedByLabel.textContent =
                'Freigegeben durch: ' +
                invoiceNote.changedBy +
                ' am ' +
                // our system doesn't store the timezone, so we need to add 1 hour to the date to get the correct date
                //it's a workaround to get the correct date (which can be different depending on the timezone)
                new Date(new Date(invoiceNote.changedAt).getTime() + 60 * 60 * 1000).toLocaleDateString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              clickedByLabel.style.display = 'block'
            }
            if(invoiceNote.checkedManagerApproval){
              clickedByLabelManagerApproval.textContent =
              'Freigegeben durch Manager: ' +
              invoiceNote.changedManagerApprovalBy +
              ' am ' +
              new Date(new Date(invoiceNote.changedManagerApprovalAt).getTime() + 60 * 60 * 1000).toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
              clickedByLabelManagerApproval.style.display = 'block'
            }

            // Render the list of attachment names
            if (invoiceAttachments && invoiceAttachments.length > 0) {
              invoiceAttachments.forEach((attachment) => {
                var attachmentItem = document.createElement('div')
                var attachmentLink = document.createElement('a')
                var attachmentImage = document.createElement('img')

                // Set the image source and style
                attachmentImage.src = `https://${host}/document.svg` // Placeholder image URL
                attachmentImage.alt = 'Document'
                attachmentImage.style.marginRight = '8px'
                attachmentImage.style.verticalAlign = 'middle'
                attachmentImage.style.width = '15px'
                attachmentImage.style.height = '15px'

                // Set the link properties
                attachmentLink.onclick = function () {
                  const invoiceId = window.location.pathname.split('/').pop()
                  const domain = resolveDomain(JSON.parse(localStorage.auth).domain)
                  let baseUrl

                  switch (domain) {
                    case 'erste-hausverwaltung-dus':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSDsseldorf/Freigegebene Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSDsseldorf/Freigegebene Dokumente'
                      break
                    case 'hauscon':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSHauscon/Freigegebene%20Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSHauscon/Freigegebene Dokumente'
                      break
                    case 'cig':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSCIG/Freigegebene Dokumente/Forms/Standardansicht%20%20Ordner.aspx?id=/sites/NeovaroDMSCIG/Freigegebene Dokumente'
                      break
                    case 'zieglmeier':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSZieglmeier/Freigegebene%20Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSZieglmeier/Freigegebene Dokumente'
                      break
                    case 'erste-hausverwaltung-2':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSTesting/Freigegebene%20Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSTesting/Freigegebene Dokumente'
                      break
                    case 'ehv-service':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSEHVService/Freigegebene%20Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSEHVService/Freigegebene Dokumente'
                      break
                    case 'sgv-murr':
                      baseUrl =
                        'https://erstehausverwaltung.sharepoint.com/sites/NeovaroDMSsgv-murr/Freigegebene%20Dokumente/Forms/AllItems.aspx?id=/sites/NeovaroDMSsgv-murr/Freigegebene Dokumente'
                      break
                    // Add more cases for different domains as needed
                    default:
                      baseUrl = '/'
                  }

                  window.open(
                    `${baseUrl}/Rechnungsanhänge/${invoiceId}`,
                    '_blank'
                  )
                }
                attachmentLink.style.textDecoration = 'none'
                attachmentLink.style.color = '#333'
                attachmentLink.textContent = attachment.name

                // Append the image and link to the attachment item
                attachmentItem.appendChild(attachmentImage)
                attachmentItem.appendChild(attachmentLink)

                attachmentListContainer.appendChild(attachmentItem)
              })
            }
          } else {
            console.error('Error:', xhr.statusText)
            alert('An error occurred while fetching the data.')
          }
        }
      }
      xhr.send(
        JSON.stringify({
          domain: resolveDomain(JSON.parse(localStorage.auth).domain),
          invoiceId: window.location.pathname.split('/').pop(),
        })
      )

      notesSection.appendChild(indicator)
      notesSection.appendChild(heading)
      notesSection.appendChild(textarea)
      notesSection.appendChild(addButton)
      notesSection.appendChild(attachmentListContainer) // Append the attachment list container
      notesSection.appendChild(checkboxContainer)
      notesSection.appendChild(checkboxManagerApprovaContainer)

      checkboxContainer.appendChild(checkbox)
      checkboxContainer.appendChild(checkboxLabel)
      notesSection.appendChild(clickedByLabel)

      checkboxManagerApprovalChecboxContainer.appendChild(checkboxManagerApproval)
      checkboxManagerApprovalChecboxContainer.appendChild(checkboxLabelManagerApproval)
      checkboxManagerApprovaContainer.appendChild(checkboxManagerApprovalChecboxContainer)
      checkboxManagerApprovaContainer.appendChild(clickedByLabelManagerApproval)

      pageContent.parentNode.insertBefore(notesSection, pageContent)
    }
  }, 100)
}

function setupDuplicateInvoiceCheck() {
  const checkFormSectionInterval = setInterval(() => {
    const formSection = document.querySelector('div.FormSection#InvoiceProcessing');
    
    if (formSection) {
      clearInterval(checkFormSectionInterval);
      
      const saveButton = formSection.querySelector('button.ant-btn.section-submit');
      const propertySelectContainer = formSection.querySelector('.ant-select-in-form-item');
      const invoiceNumberInput = formSection.querySelector('input.ant-input[placeholder="Bitte ausfüllen..."]');
      
      if (saveButton && propertySelectContainer && invoiceNumberInput) {
        
        // the wrapper intercepts clicks to the save button
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        
        saveButton.parentNode.insertBefore(wrapper, saveButton);
        wrapper.appendChild(saveButton);
        
        let isProcessingClick = false;
        
        wrapper.addEventListener('click', async function(event) {
          if (isProcessingClick) {
            return;
          }
          
          event.preventDefault();
          event.stopPropagation();
          isProcessingClick = true;
          
          let propertyName = '';
          const propertySelectedItem = propertySelectContainer.querySelector('.ant-select-selection-item');
          
          if (propertySelectedItem) {
            propertyName = propertySelectedItem.textContent.trim();
          }
          
          const invoiceNumber = invoiceNumberInput.value.trim();
          
          if (propertyName && invoiceNumber) {
            const isDuplicate = await checkDuplicateInvoice(propertyName, invoiceNumber);
            
            if (isDuplicate) {
              console.log("Duplicate invoice detected");
              
              showToast(
                `WARNUNG: Eine Rechnung mit der Nummer "${invoiceNumber}" existiert bereits für das Objekt "${propertyName}".`,
                'warning',
                5000
              );
              
              invoiceNumberInput.style.border = '2px solid rgb(250, 43, 20)';
              setTimeout(() => {
                invoiceNumberInput.style.border = ''; 
              }, 5000);
              
              isProcessingClick = false;
            } else {
              setTimeout(() => {
                saveButton.dispatchEvent(new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
                }));
                setTimeout(() => { isProcessingClick = false; }, 0);
              }, 0);
            }
          } else {
            setTimeout(() => {
              saveButton.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              }));
              setTimeout(() => { isProcessingClick = false; }, 0);
            }, 0);
          }
        }, true);
      } else {
        console.log("Save button not found, skipping duplicate invoice check setup");
      }
    }
  }, 500);
}

const checkDuplicateInvoice = async (propertyName, invoiceNumber) => {
  if (!propertyName || !invoiceNumber) {
    return false;
  }
  
  const apiUrl = `${baseApiUrl}/api/impowerX/invoices?propertyName=${encodeURIComponent(propertyName)}`;
  
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      console.error('API response error:', response.status);
      return false;
    }
    
    const data = await response.json();
    const invoices = data?.content?.content || [];
    
    if (Array.isArray(invoices)) {
      const isDuplicate = invoices.some(invoice => 
        invoice.invoiceNumber && invoice.invoiceNumber.toLowerCase() === invoiceNumber.toLowerCase()
      );
      
      return isDuplicate;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking for duplicate invoice:', error);
    return false;
  }
};

// Skonto Calculator functionality
const setupSkontoCalculator = () => {
  let skontoObserver = null
  let isSkontoInjected = false

  const injectSkontoCalculator = () => {
    // Check if Skonto calculator is already injected
    if (document.querySelector('#skonto-calculator-container')) {
      return true // Return true to indicate success
    }

    console.log('Setting up Skonto calculator')
    
    // Find the target container where we want to inject the Skonto calculator
    const targetContainer = document.querySelector(
      '#totalNetAmount > div.sub-section-content > div:nth-child(2)'
    )

    if (targetContainer) {
      // Get the original amount when first injecting
      const amountInput = document.querySelector(
        '#totalNetAmount > div.sub-section-content > div:nth-child(1) > div > div > div > div > div.ant-col.ant-form-item-control > div.ant-form-item-control-input > div > span > input'
      )
      if (amountInput && amountInput.value) {
        // Store original amount per invoice ID - get current invoice ID dynamically
        const currentInvoiceId = window.location.pathname.split('/').pop()
        if (!window.originalSkontoAmounts) {
          window.originalSkontoAmounts = {}
        }
        window.originalSkontoAmounts[currentInvoiceId] = amountInput.value
      }

      // Create the Skonto calculator container
      const skontoContainer = document.createElement('div')
      skontoContainer.id = 'skonto-calculator-container'
      skontoContainer.className = 'skonto-calculator-wrapper'
      skontoContainer.style.cssText = `
        width: 100%;
        margin-top: 16px;
        padding-left: 16px;
      `

      // Create the toggle button
      const toggleButton = document.createElement('button')
      toggleButton.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
          <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="currentColor"></path>
        </svg>
        Skonto
      `
      toggleButton.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 16px;
        border: none;
        border-radius: 6px;
        background-color: rgba(0, 0, 0, 0.08);
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        width: 100%;
      `
      toggleButton.onmouseover = () => {
        toggleButton.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
      }
      toggleButton.onmouseout = () => {
        toggleButton.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'
      }

      // Create the Skonto calculator content
      const skontoContent = document.createElement('div')
      skontoContent.id = 'skonto-content'
      skontoContent.style.cssText = `
        display: none;
        width: 100%;
        margin-top: 12px;
      `

      // Create the label
      const label = document.createElement('div')
      label.innerHTML = '<span style="font-size: 14px; color: rgba(0, 0, 0, 0.85); line-height: 22px; font-weight: 400; display: block; margin-bottom: 8px;">Skonto in %</span>'
      label.style.marginBottom = '12px'

      // Create the buttons container
      const buttonsContainer = document.createElement('div')
      buttonsContainer.style.cssText = `
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
        width: 100%;
      `

      // Create Skonto percentage buttons
      const skontoPercentages = [1, 2, 3, 4, 5]
      skontoPercentages.forEach(percentage => {
        const button = document.createElement('button')
        button.textContent = percentage + '%'
        button.dataset.percentage = percentage
        button.style.cssText = `
          padding: 8px 16px;
          border: none;
          border-radius: 6px;
          background-color: rgba(0, 0, 0, 0.08);
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s;
          flex: 1;
        `
        button.onmouseover = () => {
          if (!button.classList.contains('selected')) {
            button.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
          }
        }
        button.onmouseout = () => {
          if (!button.classList.contains('selected')) {
            button.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'
          } else {
            button.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
          }
        }
        button.onclick = (event) => {
          event.preventDefault()
          event.stopPropagation()
          
          // Remove selected class from all buttons
          document.querySelectorAll('[data-percentage]').forEach(btn => {
            btn.classList.remove('selected')
            btn.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'
            btn.style.color = 'rgba(0, 0, 0, 0.85)'
          })
          
          // Add selected class to clicked button
          button.classList.add('selected')
          button.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
          button.style.color = 'rgba(0, 0, 0, 0.85)'
          
          // Show reset button
          const resetButton = document.querySelector('#skonto-reset-button')
          if (resetButton) {
            resetButton.style.display = 'inline-block'
          }
          
          calculateSkonto(percentage)
        }
        buttonsContainer.appendChild(button)
      })

      // Create reset button
      const resetButton = document.createElement('button')
      resetButton.id = 'skonto-reset-button'
      resetButton.textContent = 'Zurücksetzen'
      resetButton.style.cssText = `
        padding: 8px 16px;
        border: none;
        border-radius: 6px;
        background-color: rgba(0, 0, 0, 0.08);
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        display: none;
      `
      resetButton.onmouseover = () => {
        resetButton.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
      }
      resetButton.onmouseout = () => {
        resetButton.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'
      }
      resetButton.onclick = resetToOriginal

      // Assemble the Skonto calculator
      skontoContent.appendChild(label)
      skontoContent.appendChild(buttonsContainer)
      skontoContent.appendChild(resetButton)
      skontoContainer.appendChild(toggleButton)
      skontoContainer.appendChild(skontoContent)

      // Add toggle functionality
      toggleButton.onclick = () => {
        const isVisible = skontoContent.style.display !== 'none'
        if (isVisible) {
          skontoContent.style.display = 'none'
          toggleButton.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
              <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="currentColor"></path>
            </svg>
            Skonto
          `
          resetToOriginal()
          
          // Hide reset button when closing
          const resetButton = document.querySelector('#skonto-reset-button')
          if (resetButton) {
            resetButton.style.display = 'none'
          }
        } else {
          skontoContent.style.display = 'block'
          toggleButton.innerHTML = `
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z" fill="currentColor"></path>
            </svg>
            Skonto
          `
        }
      }

      // Insert the Skonto calculator into the target container
      targetContainer.appendChild(skontoContainer)
      isSkontoInjected = true
      return true // Return true to indicate successful injection
    }
    return false // Return false if target container not found
  }

  const removeSkontoCalculator = () => {
    const skontoContainer = document.querySelector('#skonto-calculator-container')
    if (skontoContainer) {
      skontoContainer.remove()
      isSkontoInjected = false
      console.log('Removed Skonto calculator')
    }
  }

  // Clean injection mechanism using interval
  let injectionInterval = null
  
  const attemptInjection = () => {
    if (injectSkontoCalculator()) {
      // Successfully injected, clear the interval
      if (injectionInterval) {
        clearInterval(injectionInterval)
        injectionInterval = null
      }
    }
  }

  // Create MutationObserver to watch for #totalNetAmount element
  skontoObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Check for added nodes
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is #totalNetAmount or contains it
          if (node.id === 'totalNetAmount' || node.querySelector('#totalNetAmount')) {
            console.log('totalNetAmount element detected, attempting Skonto calculator injection')
            // Start interval for injection attempts
            if (!injectionInterval) {
              injectionInterval = setInterval(attemptInjection, 100)
            }
          }
        }
      })

      // Check for removed nodes
      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the removed node is #totalNetAmount or contains it
          if (node.id === 'totalNetAmount' || node.querySelector('#totalNetAmount')) {
            console.log('totalNetAmount element removed, removing Skonto calculator')
            removeSkontoCalculator()
            // Clear injection interval if it's running
            if (injectionInterval) {
              clearInterval(injectionInterval)
              injectionInterval = null
            }
          }
        }
      })
    })
  })

  // Start observing the document body for changes
  if (document.body) {
    skontoObserver.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Also check if #totalNetAmount already exists on page load
    if (document.querySelector('#totalNetAmount')) {
      injectionInterval = setInterval(attemptInjection, 100)
    }
  } else {
    // If document.body is not available yet, wait for it
    const waitForBody = setInterval(() => {
      if (document.body) {
        clearInterval(waitForBody)
        skontoObserver.observe(document.body, {
          childList: true,
          subtree: true
        })

        // Also check if #totalNetAmount already exists on page load
        if (document.querySelector('#totalNetAmount')) {
          injectionInterval = setInterval(attemptInjection, 100)
        }
      }
    }, 100)
  }

  // Return cleanup function
  return () => {
    if (skontoObserver) {
      skontoObserver.disconnect()
    }
    removeSkontoCalculator()
    // Clear injection interval if it's running
    if (injectionInterval) {
      clearInterval(injectionInterval)
      injectionInterval = null
    }
  }
}

// Function to calculate Skonto
const calculateSkonto = (percentage) => {
  try {
    // Get the current invoice ID dynamically from the URL
    const currentInvoiceId = window.location.pathname.split('/').pop()
    
    // Get the original amount from the input
    const amountInput = document.querySelector(
      '#totalNetAmount > div.sub-section-content > div:nth-child(1) > div > div > div > div > div.ant-col.ant-form-item-control > div > div > div > div > div > input'
    )
    
    if (!amountInput) {
      console.warn('Amount input not found')
      return
    }

    // Use the stored original amount or get it from the input if not stored
    let originalAmount = window.originalSkontoAmounts?.[currentInvoiceId]
    if (!originalAmount) {
      originalAmount = amountInput.value || ''
      if (originalAmount) {
        if (!window.originalSkontoAmounts) {
          window.originalSkontoAmounts = {}
        }
        window.originalSkontoAmounts[currentInvoiceId] = originalAmount
      }
    }

    if (!originalAmount) {
      console.warn('No original amount available for Skonto calculation')
      return
    }

    const grossAmount = originalAmount.replace(/\./g, '').replace(',', '.')
    const numericAmount = parseFloat(grossAmount)
    
    if (isNaN(numericAmount)) {
      console.warn('Invalid amount format for Skonto calculation')
      return
    }

    const postSkontoGrossAmount = numericAmount * (1 - percentage / 100)

    // Update the label to show original amount
    const labelElement = document.querySelector(
      '#totalNetAmount > div.sub-section-content > div:nth-child(1) > div > div > div > div > div.ant-col.ant-form-item-label > label'
    )
    if (labelElement) {
      labelElement.innerHTML = `Gesamtbetrag brutto (Originalbetrag &nbsp; <span id="originalAmount">${numericAmount.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}</span>) *`
    }

    // Update the input value
    if (amountInput) {
      amountInput.focus()
      
      // Use the native input value setter to trigger React's onChange
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set

      if (nativeInputValueSetter) {
        nativeInputValueSetter.call(
          amountInput,
          postSkontoGrossAmount.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        )
        amountInput.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }
  } catch (error) {
    console.error('Error calculating Skonto:', error)
  }
}

// Function to reset to original amount
const resetToOriginal = () => {
  try {
    // Get the current invoice ID dynamically from the URL
    const currentInvoiceId = window.location.pathname.split('/').pop()
    
    const amountInput = document.querySelector(
      '#totalNetAmount > div.sub-section-content > div:nth-child(1) > div > div > div > div > div.ant-col.ant-form-item-control > div > div > div > div > div > input'
    )
    
    if (!amountInput) {
      console.warn('Amount input not found')
      return
    }

    // Use the stored original amount
    let originalAmount = window.originalSkontoAmounts?.[currentInvoiceId]
    if (!originalAmount) {
      console.warn('No original amount available for reset')
      return
    }

    // Parse the original amount correctly (handle German number format)
    const grossAmount = originalAmount.replace(/\./g, '').replace(',', '.')
    const numericAmount = parseFloat(grossAmount)
    
    if (isNaN(numericAmount)) {
      console.warn('Invalid amount format for reset')
      return
    }

    // Reset the label
    const labelElement = document.querySelector(
      '#totalNetAmount > div.sub-section-content > div:nth-child(1) > div > div > div > div > div.ant-col.ant-form-item-label > label'
    )
    if (labelElement) {
      labelElement.innerHTML = 'Gesamtbetrag brutto *'
    }

    // Reset the input value
    if (amountInput) {
      amountInput.focus()
      
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set

      if (nativeInputValueSetter) {
        nativeInputValueSetter.call(
          amountInput,
          numericAmount.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        )
        amountInput.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }

    // Clear selected state from all buttons
    document.querySelectorAll('[data-percentage]').forEach(btn => {
      btn.classList.remove('selected')
      btn.style.backgroundColor = 'rgba(0, 0, 0, 0.08)'
      btn.style.color = 'rgba(0, 0, 0, 0.85)'
    })

    // Hide reset button
    const resetButton = document.querySelector('#skonto-reset-button')
    if (resetButton) {
      resetButton.style.display = 'none'
    }
  } catch (error) {
    console.error('Error resetting to original amount:', error)
  }
}

// Initialize Skonto calculator when the page loads
// Use the invoice ID from the URL as the unique key
const invoiceId = window.location.pathname.split('/').pop() // Gets the last part like "INV06816"
const cleanupKey = `skonto_${invoiceId}`

// Initialize the cleanup registry if it doesn't exist
if (!window.skontoCleanupRegistry) {
  window.skontoCleanupRegistry = {}
}

// Call cleanup from previous execution if it exists
if (window.skontoCleanupRegistry[cleanupKey]) {
  window.skontoCleanupRegistry[cleanupKey]()
  delete window.skontoCleanupRegistry[cleanupKey]
}

// Store the new cleanup function
window.skontoCleanupRegistry[cleanupKey] = setupSkontoCalculator()

// Clean up when leaving this page (for non-invoice page navigation)
const cleanupOnPageChange = () => {
  // Get the current invoice ID dynamically from the URL
  const currentInvoiceId = window.location.pathname.split('/').pop()
  const currentCleanupKey = `skonto_${currentInvoiceId}`
  
  if (window.skontoCleanupRegistry[currentCleanupKey]) {
    window.skontoCleanupRegistry[currentCleanupKey]()
    delete window.skontoCleanupRegistry[currentCleanupKey]
  }
  // Also clean up the original amount data
  if (window.originalSkontoAmounts && window.originalSkontoAmounts[currentInvoiceId]) {
    delete window.originalSkontoAmounts[currentInvoiceId]
  }
}

// Listen for page changes
window.addEventListener('beforeunload', cleanupOnPageChange)
window.addEventListener('pagehide', cleanupOnPageChange)